// La TORTUGONA — la mascota de Ona (la de los eventos infantiles): tortuga
// BÍPEDA estilo ninja, de pie sobre dos patas, saludando. Es el trofeo de la
// casa en oro/plata/bronce y sustituye a las medallas en todos los rankings.
// Dibujo propio, mismo lenguaje redondeado de la iconografía Ona.
import React from 'react';
import Svg, { Circle, Ellipse, Path } from 'react-native-svg';

export type Metal = 'oro' | 'plata' | 'bronce' | 'noa';

const METALES: Record<Metal, { fill: string; claro: string; oscuro: string }> = {
  oro: { fill: '#F5C34B', claro: '#FBE199', oscuro: '#7A4E10' },
  plata: { fill: '#C7D3DD', claro: '#E9EFF4', oscuro: '#4F6878' },
  bronce: { fill: '#D2884B', claro: '#EBBB8D', oscuro: '#6E3F17' },
  noa: { fill: '#1ED3C7', claro: '#8FF2E7', oscuro: '#0B4A45' },   // Noa, la mascota, en su color de marca
};

export default function Tortugona({ metal, size = 22 }: { metal: Metal; size?: number }) {
  const c = METALES[metal];
  const st = { stroke: c.oscuro, strokeWidth: 1, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const };
  // extremidades con contorno: trazo oscuro debajo + trazo del metal encima
  const limb = (d: string) => (
    <>
      <Path d={d} stroke={c.oscuro} strokeWidth={3.1} strokeLinecap="round" fill="none" />
      <Path d={d} stroke={c.fill} strokeWidth={1.9} strokeLinecap="round" fill="none" />
    </>
  );
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24">
      {/* caparazón a la espalda */}
      <Ellipse cx={12} cy={13.4} rx={6.9} ry={6.2} fill={c.oscuro} {...st} />
      {/* piernas */}
      {limb('M10.1 17.6 L9.5 20.2')}
      {limb('M13.9 17.6 L14.5 20.2')}
      {/* pies */}
      <Ellipse cx={9} cy={20.9} rx={1.7} ry={1} fill={c.fill} {...st} />
      <Ellipse cx={15} cy={20.9} rx={1.7} ry={1} fill={c.fill} {...st} />
      {/* brazos: izquierdo saludando, derecho abajo */}
      {limb('M8.7 11.4 L5.9 8.9')}
      {limb('M15.3 11.4 L17.9 13.6')}
      {/* cuerpo: plastrón */}
      <Ellipse cx={12} cy={13.4} rx={4.4} ry={5} fill={c.claro} {...st} />
      <Path d="M9.4 12.2 h5.2 M9.7 14.6 h4.6" stroke={c.oscuro} strokeWidth={0.8} fill="none" />
      {/* cabeza */}
      <Circle cx={12} cy={5.9} r={3.5} fill={c.fill} {...st} />
      {/* ojos y sonrisa */}
      <Circle cx={10.7} cy={5.5} r={0.55} fill={c.oscuro} />
      <Circle cx={13.3} cy={5.5} r={0.55} fill={c.oscuro} />
      <Path d="M10.6 7 Q12 8.1 13.4 7" stroke={c.oscuro} strokeWidth={0.9} fill="none" strokeLinecap="round" />
    </Svg>
  );
}
